const AppConfig = {
  key: {
    LoggedIn: 'loggedInManageLottokey',
    GlobalMarketKey: 'SelectedGlobalMarket'
  }
}

export default AppConfig;
